import { Component } from "@angular/core";
import { AuthService } from "./shared/services/auth.service";
import { LanguageService } from "./core/services/language.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false
})
export class AppComponent {
  constructor(private authService: AuthService, private languageService: LanguageService) {
    // this.authService.autologin();
  }
}
